export function sortOrderToNumber(sort: number | string): number {
  if (typeof sort === 'number') {
    if (sort === 1) {
      return 1;
    } else {
      return -1;
    }
  } else {
    if (sort.toLowerCase() === 'asc') {
      return 1;
    } else {
      return -1;
    }
  }
}
